import { getAuthToken } from "@/features/shared/features/authentication";
import { DimensionValueSet } from "@/lib/dimensions";
import { appendVerticalQueryParam } from "@/lib/dimensions/helpers";

export default class ObservedLayerLegendImageLoader {
  private layerId;

  constructor(layerId: string) {
    this.layerId = layerId;
  }

  async loadLegendImage(dimensionValues: DimensionValueSet): Promise<Blob | undefined> {
    const response = await fetch(this.legendImageUrl(dimensionValues), {
      headers: {
        Authorization: `Bearer ${getAuthToken()?.access_token}`,
      },
    });

    if (!response.ok) throw new Error(response.statusText, { cause: response });

    return response.blob();
  }

  private legendImageUrl(dimensionValues: DimensionValueSet): string {
    const queryString = new URLSearchParams({
      time: dimensionValues["time"]?.queryStringValue,
    });
    appendVerticalQueryParam(queryString, dimensionValues);

    return `${import.meta.env.VITE_API_BASE_PATH}/parameters/observed/map_layers/${this.layerId}/legend?${queryString.toString()}`;
  }
}
